<template lang="pug"></template>

<script>
export default {
    name: 'BotaoFiscalizacaoOperacoes',
    componentOptions: {
        title: 'listaFiscalizacaoOperacao',
        actions: [
            [
                {
                    name: 'Fiscalização',
                    iconClass: 'lyra-icon lyra-search-map',
                    showView: false,
                    action: 'abrirFiscalizacaoOperacoes',
                    route: 'operacaoFiscalizacao'
                }
            ]
        ]
    },

    methods: {
        abrirFiscalizacaoOperacoes() {
            if (this.$route.name !== 'operacaoFiscalizacao') {
                this.$router.push({ name: 'operacaoFiscalizacao' });
            } else {
                this.$$router.go();
            }
        }
    }
};
</script>
